import React, { Component, Fragment } from 'react'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import { processResponse } from '../../../utilities/processResponse';

class SubmissionModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            show:false
        }
    }

    componentDidMount() {
        this.setState({show:this.props.active});
    }

    componentWillReceiveProps(nextProps) {
        this.setState({show:nextProps.active});
    }

    handleOpen = () => {
        this.setState({show:!this.state.show});
    }

    handleClose = () => {
        this.setState({show:false});
        this.props.closeSubmissionModal();
    }

    handleFinalSubmit = () => {
        this.handleClose();
        this.props.handleFinalAsSubmitButton(null, null, null, "FinalSubmit");
    }

    render() {
    const { pageInstrumentConfiguration, isRequiredCount, secondChance } = this.props;
    const { buttons, sections, submissionModal, reviewPage, suppressSaveForLater, properties, pageNextButtonKey } = pageInstrumentConfiguration;
    const unansweredRequired = sections.hasOwnProperty(submissionModal.unansweredRequiredSectionKey) ? sections[submissionModal.unansweredRequiredSectionKey].content:null;
    const unansweredUnrequired = sections.hasOwnProperty(submissionModal.unansweredUnrequiredSectionKey) ? sections[submissionModal.unansweredUnrequiredSectionKey].content:null;
    return (
            <Fragment>
                <Modal
                    animation={true}
                    // show={unansweredRequired !== null && unansweredUnrequired !== null ? this.state.show: false}
                    show={this.state.show}
                    aria-labelledby="contained-modal-title-vcenter"
                    onHide={this.handleClose}
                    animation={false}
                    centered
                >
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body className="text-center">
                        {isRequiredCount !== 0 ?
                            <>
                                {sections.hasOwnProperty(submissionModal.unansweredRequiredSectionKey) ?  <span
                                    key={sections[submissionModal.unansweredRequiredSectionKey].key}
                                    dangerouslySetInnerHTML={{__html:processResponse(sections[submissionModal.unansweredRequiredSectionKey].content)}}
                                    className={`_SubmissionModalUnansweredRequiredSection ${sections[submissionModal.unansweredRequiredSectionKey].className}`}
                                ></span>:null}
                                {!reviewPage.pageDisabled ? <div
                                    className={`_SubmissionModalReviewUnansweredResponsesButton ${buttons[submissionModal.reviewUnansweredResponsesButtonKey].buttonCssClass}`}
                                    onClick={() => { this.setState({show:false}); this.props.openModal("unanswered", true)}}
                                >
                                    {buttons[submissionModal.reviewUnansweredResponsesButtonKey].buttonText}
                                </div>:null}
                            </>
                        : secondChance !== 0 ?
                        <>
                        {sections.hasOwnProperty(submissionModal.unansweredUnrequiredSectionKey) ?
                            <span
                                key={sections[submissionModal.unansweredUnrequiredSectionKey].key}
                                dangerouslySetInnerHTML={{__html:processResponse(sections[submissionModal.unansweredUnrequiredSectionKey].content)}}
                                className={`_SubmissionModalUnansweredUnrequiredSection ${sections[submissionModal.unansweredUnrequiredSectionKey].className}`}
                        ></span>:null}
                        <div>
                            {!reviewPage.pageDisabled? <Button
                                key={buttons[submissionModal.reviewAllResponsesButtonKey].key}
                                className={`_SubmissionModalReviewAllResponsesButton ${buttons[submissionModal.reviewAllResponsesButtonKey].buttonCssClass}`}
                                onClick={() => { this.props.openModal("review", false)}}
                            >
                                {buttons[submissionModal.reviewAllResponsesButtonKey].buttonText}
                            </Button>:<br/>}
                        </div>
                        <div className="modal-button-content">
                            {buttons.hasOwnProperty(submissionModal.submitAsFinalButtonKey) ?<Button
                                key={buttons[submissionModal.submitAsFinalButtonKey].key}
                                // className={`_SubmissionModalSubmitAsFinalButton ${buttons[submissionModal.submitAsFinalButtonKey].buttonCssClass}`}
                                className={properties.daisyChainOption !== "1" ? `_SubmissionModalSubmitAsFinalButton ${buttons[submissionModal.submitAsFinalButtonKey].buttonCssClass || ""}`:`_PageNextButton ${buttons[pageNextButtonKey].buttonCssClass}`}
                                onClick={() => {
                                    this.handleClose()
                                    this.props.handleFinalAsSubmitButton(null, null, null, "FinalSubmit")}
                                }
                            >
                                {/* {buttons[submissionModal.submitAsFinalButtonKey].buttonText} */}
                                { properties.daisyChainOption !== "1" ? buttons[submissionModal.submitAsFinalButtonKey].buttonText : buttons[pageNextButtonKey].buttonText}
                            </Button>:null}
                        </div>
                        <div>
                            {!suppressSaveForLater ?
                            <Button
                                key={buttons[submissionModal.saveForLaterWorkButtonKey].key}
                                className={`_SubmissionModalSaveForLaterWorkButton ${buttons[submissionModal.saveForLaterWorkButtonKey].buttonCssClass}`}
                                onClick={() => this.props.redirectSavePage()}
                            >
                                {buttons[submissionModal.saveForLaterWorkButtonKey].buttonText}
                            </Button>:null}
                        </div></>:null }
                    </Modal.Body>
                </Modal>
            </Fragment>
        )
    }
}

export default SubmissionModal;
